import { defineMessages } from 'react-intl';
import { takeEvery, call, select, all, put } from 'redux-saga/effects';

import { createInfoBanner } from 'components/Banner';
import { createErrorSnackbar } from 'components/Snackbar';
import { closeModal } from 'components/Modal';
import { EMAIL_TYPES } from 'constants/logic';
import URLS from 'constants/urls';
import { transformKeysToSnakeCase } from 'helpers/core';
import { selectActiveVenueId } from 'selectors/general';

import sharedMessages from './SkuOrder.messages';

// Keep 5xx on in-app flows (banner + modal) instead of the full-page InternalError screen.
const HTTP_OPTIONS = { ignoreInternalError: true };

const messages = defineMessages({
  emailSent: {
    id: 'sku-orders.email-sent',
    defaultMessage: 'Email sent successfully.',
  },
  emailError: {
    id: 'sku-orders.email-error',
    defaultMessage: 'Failed to send email. Please try again.',
  },
});

export const EMAIL_ORDER_CUSTOMER = 'SKU_ORDERS/EMAIL_ORDER_CUSTOMER';

export const emailOrderCustomer = (values, formAsyncFns) => ({
  type: EMAIL_ORDER_CUSTOMER,
  formValues: values,
  formAsyncFns,
});

export function* doEmailOrderCustomer({ httpClient, intl }, action) {
  const { message: messageContent, recipients, subjectValues } = action.formValues;
  const { resolveSubmit, rejectSubmit } = action.formAsyncFns;
  const venueId = yield select(selectActiveVenueId);
  const subject = intl.formatMessage(sharedMessages.emailModalSubject, subjectValues);

  const payload = transformKeysToSnakeCase({
    email: {
      messageType: EMAIL_TYPES.GENERIC_TO_SOME_USERS,
      messageContent: messageContent.replace(/\n/g, '<br />'),
      subject,
    },
    recipients,
  });

  try {
    yield call([httpClient, httpClient.post], URLS.sku.messageMembers(venueId), payload, HTTP_OPTIONS);
    yield all([call(resolveSubmit), put(closeModal()), put(createInfoBanner(messages.emailSent))]);
  } catch (error) {
    yield all([call(rejectSubmit), put(closeModal()), put(createErrorSnackbar(messages.emailError))]);
  }
}

export function* watchEmailOrderCustomer(dependencies) {
  yield takeEvery(EMAIL_ORDER_CUSTOMER, doEmailOrderCustomer, dependencies);
}
